import React from "react";
import LeagueContainer from "../containers/LeagueContainer";

function Home() {
  return <LeagueContainer></LeagueContainer>;
}

export default Home;
